var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatimentDroite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 275 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.18;fill:url(#D\xE9grad\xE9_sans_nom_57);}.cls-2{fill:#f4efed;}.cls-12,.cls-3{fill:#d7d8e6;}.cls-4{fill:#40444c;}.cls-5{fill:#75633b;}.cls-6{fill:#c1b7b4;}.cls-7{fill:#fff;}.cls-18,.cls-8{fill:none;}.cls-8{stroke:#544b40;}.cls-12,.cls-16,.cls-18,.cls-8{stroke-miterlimit:10;}.cls-9{fill:#08080c;}.cls-10{fill:#dd5817;}.cls-11{fill:#edf1f4;}.cls-12{stroke:#000;}.cls-13{fill:#81c7e2;}.cls-14,.cls-16{fill:#304a54;}.cls-14,.cls-16,.cls-18{opacity:0.38;}.cls-15{fill:#5579ad;}.cls-16,.cls-18{stroke:#304a54;}.cls-16{stroke-width:0.5px;}.cls-17{fill:#b3c0c4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 137.5,
    y1: 98,
    x2: 137.5,
    y2: 329.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ec8da",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6391b7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Finaux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batiment_droite_1",
    "data-name": "batiment droite 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 98,
    width: 275,
    height: 231.56
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "batiment_droite_2",
    "data-name": "batiment droite 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 329 219 329 219 76 54 76 0 76 0 329"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87,
    y: 92,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87,
    y: 114,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87,
    y: 92,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87,
    y: 102,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32,
    y: 92,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32,
    y: 114,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32,
    y: 92,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32,
    y: 102,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139,
    y: 92,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139,
    y: 114,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139,
    y: 92,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139,
    y: 102,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87,
    y: 148,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87,
    y: 170,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87,
    y: 148,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87,
    y: 158,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139,
    y: 148,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139,
    y: 170,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139,
    y: 148,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139,
    y: 158,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87,
    y: 206,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87,
    y: 228,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87,
    y: 206,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87,
    y: 216,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139,
    y: 206,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139,
    y: 228,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139,
    y: 206,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139,
    y: 216,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87,
    y: 264,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87,
    y: 286,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87,
    y: 264,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87,
    y: 274,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32,
    y: 148,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32,
    y: 170,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32,
    y: 148,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32,
    y: 158,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32,
    y: 206,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32,
    y: 228,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32,
    y: 206,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32,
    y: 216,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32,
    y: 264,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32,
    y: 286,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32,
    y: 264,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32,
    y: 274,
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139,
    y: 264,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139,
    y: 286,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139,
    y: 264,
    width: 26,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139,
    y: 274,
    width: 3,
    height: 12
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 76,
    width: 219,
    height: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.5,
    y1: 81.5,
    x2: 219,
    y2: 82
  }), /*#__PURE__*/React.createElement("g", {
    id: "c\\xF4t\\xE9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219,
    y: 76,
    width: 35,
    height: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 245,
    y: 83.14,
    width: 9,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 219,
    y: 83.14,
    width: 26,
    height: 14.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 219.5,
    y: 97.42,
    width: 25,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 219,
    y: 114.77,
    width: 26,
    height: 24.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219,
    y: 139.25,
    width: 35,
    height: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 245,
    y: 146.39,
    width: 9,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 219,
    y: 146.39,
    width: 26,
    height: 14.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 219.5,
    y: 160.67,
    width: 25,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 219,
    y: 178.02,
    width: 26,
    height: 24.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219,
    y: 202.5,
    width: 35,
    height: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 245,
    y: 209.64,
    width: 9,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 219,
    y: 209.64,
    width: 26,
    height: 14.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 219.5,
    y: 223.92,
    width: 25,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 219,
    y: 241.27,
    width: 26,
    height: 24.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219,
    y: 265.75,
    width: 35,
    height: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 245,
    y: 272.89,
    width: 9,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 219,
    y: 272.89,
    width: 26,
    height: 14.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 219.5,
    y: 287.17,
    width: 25,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 219,
    y: 304.52,
    width: 26,
    height: 24.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 219,
    y: 83,
    width: 2,
    height: 246
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 245,
    y: 83,
    width: 2,
    height: 246
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 128,
    y: 39,
    width: 126,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 128,
    y: 31,
    width: 126,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 261,
    y: 14.3,
    width: 14,
    height: 314.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "275 14 275 10 254 10 254 329 261 329 261 14 275 14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 261,
    y: 14,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "138.37 31 138 30 254 20 254 31 138.37 31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 138,
    y1: 31,
    x2: 254,
    y2: 21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "167.5 27.49 167.5 22.5 166.5 22.5 166.5 21.5 181.5 21.5 184.4 26 167.5 27.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "167.5 23.5 180.5 23.5 182.5 26.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 98,
    width: 275,
    height: 231.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatimentDroite2);
export default __webpack_public_path__ + "static/media/batiment_droite_2.a57e37757a2bb0bace777694049b0690.svg";
export { ForwardRef as ReactComponent };